import api from '@/store/api/customer/metric'

export default {
    namespaced: true,
    actions: {
        /**
         * @param {{customerId: number}} data
         * @returns {Promise<*>}
         */
        recalculateMetrics: async ({dispatch}, {customerId}) => {
            try {
                const response = await api.recalculateMetrics({
                    customer_ids: [customerId]
                })
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        }
    }
}
